<template>
  <div
    style="padding: 20px">
    <div>
      <h1 class="h1"> USER ACCOUNT CREATION </h1>
    </div>
    <el-form>
      <el-form-item label="Select Role">
        <el-select v-model="model.user_type" style="width: 100%">
          <el-option value="driver" label="Driver">Driver</el-option>
          <el-option value="sales_rep" label="Sales Agent"> Sales agent </el-option>
          <el-option value="admin" label="Sales Agent"> Admin </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Firstname">
        <el-input v-model="model.first_name"/>
      </el-form-item>

      <el-form-item label="Lastname">
        <el-input v-model="model.last_name"/>
      </el-form-item>
      <el-form-item label="Tel-no (this becomes the username for login)">
        <el-input type="number" v-model="model.username">
          <template slot="prepend">+234</template>
        </el-input>
      </el-form-item>

      <el-form-item label="Email Address">
        <el-input type="email" v-model="model.email"/>
      </el-form-item>

      <el-form-item label="Password">
        <el-input type="password" v-model="model.password"/>
      </el-form-item>

        <el-button @click="handleOnSave"  style="width: 100%;" type="primary">Save account details</el-button>
        </el-form>
  </div>
</template>

<script>
import { postUser } from '@/services/user'
export default {
  name: 'UserAddEdit',
  data () {
    return {
      model: {
        username: '',
        email: '',
        password: '',
        first_name: '',
        user_type: '',
        last_name: '',
        is_staff: true
      }
    }
  },
  mounted () {
    console.log(this.$route)
  },

  methods: {
    handleOnSave () {
      postUser(this.model)
        .then((res) => {
          // TODO use setTimeout before redirecting
          this.$message('User account saved successfully')
          setTimeout(this.gotoUserPage, 1000)
        })
        .catch(err => {
          this.$notify.error({
            title: err.response.data
          })
        })
    },

    gotoUserPage () {
      this.$router.push({ name: 'UserAdmin' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/users/UserAddEdit.vue